<div class="app-c-form-group">
    <select class="app-c-form-control" name="userId" [(ngModel)]="userId" (ngModelChange)="onSelectUser($event)">
        <option [value]="-1">Select a user</option>
        <option [value]="-1">All</option>
        <option *ngFor="let user of users" [value]="user.id">
            {{user.fullName}} - {{user.email}}
        </option>
    </select>
</div>
